import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
    routes: [
      {
        path: '/',
        name: 'Home',
        component: resolve => require(['@/components/EconomicCalendar'], resolve)
      },
      {
        path: '/EconomicCalendar',
        name: 'EconomicCalendar',
        component: resolve => require(['@/components/EconomicCalendar'], resolve)
      },
      {
        path: '/Newsflash',
        name: 'Newsflash',
        component: resolve => require(['@/components/Newsflash'], resolve)
      },
      {
        path: '/information/:information_id',
        name: 'Information',
        component: resolve => require(['@/components/Information'], resolve)
      },
      {
        path: '/information_simple/:information_id',
        name: 'InformationSimple',
        component: resolve => require(['@/components/InformationSimple'], resolve)
      },
      {
        path: '/etfposition',
        name: 'EtfPosition',
        component: resolve => require(['@/components/EtfPosition'], resolve)
      },
      {
        path: '/information_list/:column',
        name: 'InformationList',
        component: resolve => require(['@/components/InformationList'], resolve)
      },
      {
        path: '/service',
        name: 'Service',
        component: resolve => require(['@/components/Service'], resolve)
      },
      {
        path: '/AboutUs',
        name: 'AboutUs',
        component: resolve => require(['@/components/AboutUs'], resolve)
      },
      {
        path: '/AdCooperation',
        name: 'AdCooperation',
        component: resolve => require(['@/components/AdCooperation'], resolve)
      },
      {
        path: '/EliteRecruitment',
        name: 'EliteRecruitment',
        component: resolve => require(['@/components/EliteRecruitment'], resolve)
      },
      {
        path: '/Feedback',
        name: 'Feedback',
        component: resolve => require(['@/components/Feedback'], resolve)
      },
      {
        path: '/TermsOfUse',
        name: 'TermsOfUse',
        component: resolve => require(['@/components/TermsOfUse'], resolve)
      },
      {
        path: '/ContactUs',
        name: 'ContactUs',
        component: resolve => require(['@/components/ContactUs'], resolve)
      },
      {
        path: '/Guide',
        name: 'Guide',
        component: resolve => require(['@/components/Guide'], resolve)
      }
    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js